// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BiXnN","toggleButton":"styles_toggleButton__dFz6E","label":"styles_label__Xlh2M","arrow":"styles_arrow__Gqrom","body":"styles_body__tZumC"};